import { TourModel } from 'api-hooks/tour/tour-list/tour-detail';
import { AuthorizationRules } from 'common/constants';
import { PopoverMenuType } from 'components/popover';
import { useAuthorization } from 'hooks/use-authorization';
import useDrawer, { DrawerProvider } from 'hooks/use-drawer';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import ViewCommissionPanel from '../panel/view-commission-panel';

export default function useStaffCommissionAction(tour: TourModel) {
  const drawer = useDrawer();
  const { t } = useTranslation();
  const { can } = useAuthorization();
  const id = tour.id;

  const staffCommissionPermission = can(AuthorizationRules.ToursGetCommission);

  const onGetStaffCommission = React.useCallback(() => {
    drawer.showCustom({
      render: (onClose) => (
        <DrawerProvider>
          <ViewCommissionPanel id={id} onClose={onClose} />
        </DrawerProvider>
      ),
    });
  }, [drawer, id]);

  const staffCommissionAction: PopoverMenuType = {
    key: `staff-commission-${id}`,
    label: t('common:view_staff_commission'),
    onClick: onGetStaffCommission,
    isAllowed: staffCommissionPermission,
  };

  return {
    onGetStaffCommission,
    staffCommissionAction,
  };
}
